var map = {
	"./en-US": 5353,
	"./en-US.js": 5353,
	"./images/alipay-receive-money.jpg": 3144,
	"./images/alipay-red-package.png": 5050,
	"./zh-CN": 5723,
	"./zh-CN.js": 5723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7086;